import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import MainDashboard2 from './MainDashboard2'
import MainDashboard from './MainDashboard'
import Monitoring from './Monitoring/Monitoring';
import MonitoringDash from './Monitoring/MonitoringDash';
import PersonMonitoring from './Monitoring/PersonMonitoring';

const AppRouter = () => {
  let defaultRoute = `/dashboard`;
  return (
     <Routes>
        <Route path="/dashboard" element={<MainDashboard/>} />
        <Route path="/dashboard-revised" element={<MainDashboard2/>} />
        <Route path="/monitoring" element={<Monitoring/>} />
        <Route path="/monitoring/:instanceId" element={<MonitoringDash/>} />
        <Route path="/monitoring/detail/:instanceId" element={<PersonMonitoring/>} />
        <Route path="*" element={<Navigate to={defaultRoute} />} />
     </Routes>
  )
}

export default AppRouter
